import { render, staticRenderFns } from "./pie-chart-loader.vue?vue&type=template&id=8d09d3b8&scoped=true"
import script from "./pie-chart-loader.vue?vue&type=script&lang=js"
export * from "./pie-chart-loader.vue?vue&type=script&lang=js"
import style0 from "./pie-chart-loader.vue?vue&type=style&index=0&id=8d09d3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d09d3b8",
  null
  
)

export default component.exports